import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import RichText from '@/_components/richText/richText/richText.vue'
import RichTextViewer from '@/_components/richText/viewer/viewer.vue'
import TokenInput from '@/views/Language/components/token-input/token-input.vue'
import AttachmentDropzone from '@/views/Attachment/components/dropzone/dropzone.vue'

import StringModel from '@/views/Language/models/string'
import StringGroupModel from '@/views/Language/models/stringGroup'
import AttachmentModel from '@/views/Attachment/model/attachment'
import StringTokenModel from '@/views/Language/models/stringToken'

@Component({
    name: 'string-input',
    components: { DialogTemplate, RichText, RichTextViewer, TokenInput, AttachmentDropzone },
})
export default class StringInput extends Mixins<MixinInterface>() {
    bottomSheet = true
    @Prop({ required: true }) props!: any

    get stringGroup(): StringGroupModel | null {
        return this.props.stringGroup
    }

    get string(): StringModel | null {
        return this.props.string
    }

    get strings(): Array<StringModel> {
        return this.props.strings
    }

    valid = true
    name = ''
    stringType = 'singleLine'
    description: string | null = null
    editorId: null | string = null
    attachmentsAdded: Array<any> = []

    stringRules = [
        (v: any) =>
            (v && v.length > 1) ||
            this.getComplexTranslations(
                'language_fe.string.dialog_input.validation.name.must_be_min_length'
            ),
        (v: any) =>
            /^[A-Za-z0-9-_\.,()]+$/.test(v) ||
            this.getComplexTranslations(
                'language_fe.string.dialog_input.validation.name.must_follow_pattern'
            ),
        (v: any) =>
            this.testName(v) ||
            this.getComplexTranslations(
                'language_fe.string.dialog_input.validation.name.must_be_unique'
            ),
    ]

    testName(input: string) {
        let res = true
        if (input.length > 1) {
            this.strings.map((stringObject: StringModel) => {
                if (
                    this.string &&
                    this.string.name.toString().toLowerCase() == input.toString().toLowerCase()
                ) {
                    res = true
                } else if (
                    stringObject.name.toString().toLowerCase() == input.toString().toLowerCase()
                ) {
                    res = false
                }
            })
        }

        return res
    }

    handleAttachmentCreated(attachments: Array<AttachmentModel>) {
        this.attachmentsAdded = attachments
    }

    loadingAttachments = false
    onGetAttachments(attachments: Array<any>) {
        if (this.string) {
            this.postAttachment(attachments, this.string)
        } else {
            this.attachmentsAdded = [...this.attachmentsAdded, ...attachments]
        }
    }

    async postAttachment(attachments: Array<any>, string: StringModel) {
        this.loadingAttachments = true
        if (string) {
            await await string.postAttachments(attachments)
        }
        this.loadingAttachments = false
    }

    async showAttachment(attachment: AttachmentModel) {
        if (this.string) {
            let res: any = await attachment.showLog(attachment, {})

            if (res && res.delete) {
                let index = this.string.attachments.findIndex((item) => item._id == attachment._id)
                this.string.attachments.splice(index, 1)

                await this.string.get()
            }
        }
    }

    deleteAttachment(index) {
        this.attachmentsAdded.splice(index, 1)
    }

    // Strin token
    stringTokensAdded: Array<any> = []
    stringTokenNew = null

    initToken() {
        this.stringTokensAdded.push({
            _id: -1,
            value: '',
            description: null,
        })
    }

    get tokens() {
        return this.string
            ? [...this.string?.tokens, ...this.stringTokensAdded]
            : this.stringTokensAdded
    }

    get isNewToken() {
        return this.tokens.length > 0 ? this.tokens[this.tokens.length - 1]._id == -1 : false
    }

    deleteToken(token, index) {
        if (token instanceof StringTokenModel) {
            this.string?.tokens.splice(index, 1)
        } else {
            if (this.string) {
                this.stringTokensAdded.splice(index - this.string?.tokens.length, 1)
            } else {
                this.stringTokensAdded.splice(index, 1)
            }
        }
    }

    async saveToken(val, description) {
        await this.string?.postToken(val, description)
        this.stringTokensAdded.pop()
    }

    init() {
        if (this.string) {
            this.name = this.string.name
            this.stringType = this.string.stringType
            this.description = this.string.description
        }
        this.editorId = crypto['randomUUID']()
    }

    loading = false

    async patchStringGroup() {
        if (this.valid && this.string) {
            this.loading = true

            let data = {
                type: this.string._type,
                id: this.string._id,
                attributes: {
                    name: this.name,
                    description: this.description ? JSON.stringify(this.description) : null,
                    stringType: this.stringType,
                },
            }

            let string = await this.string.patch(data)

            this.loading = false
            this.$emit('close', string)
        }
    }

    async postString() {
        if (this.valid) {
            this.loading = true

            let data = {
                type: 'string',
                attributes: {
                    name: this.name,
                    description: this.description ? JSON.stringify(this.description) : null,
                    stringType: this.stringType,
                },
                relationships: {
                    group: {
                        data: {
                            id: this.stringGroup?._id,
                            type: this.stringGroup?._type,
                        },
                    },
                    ...(this.stringTokensAdded.length > 0 && {
                        tokens: {
                            data: this.stringTokensAdded.map((token) => {
                                return { id: token._id, type: token._type }
                            }),
                        },
                    }),
                },
            }

            let string = await StringModel.post(data).catch(() => {
                //
            })
            await this.postAttachment(this.attachmentsAdded, string)

            this.loading = false
            this.editorId = crypto['randomUUID']()

            this.$emit('close', string)
        }
    }

    async submit() {
        if (this.valid) {
            if (this.string) {
                await this.patchStringGroup()
            } else {
                await this.postString()
            }
        }
        this.$emit('close', true)
    }

    async mounted() {
        if (this.string) {
            await this.string.get()
        }
        this.init()
    }
}
